var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('WebsiteHeader',{staticClass:"d-none d-lg-block"}),_c('Appbar',{staticClass:"d-lg-none"}),_c('NavigationDrawer',{staticClass:"d-lg-none"}),_c('v-main',[_c('transition',{attrs:{"enter-active-class":"fadeIn","leave-active-class":"fadeOut"}},[_c('router-view',{key:_vm.path,attrs:{"appear":""}})],1)],1),_c('PageFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }